(function () {
  'use strict';

  var PRIMARY_HANDLE = 'turkish-printed-rayon-viscose-jacquard-fabric';
  var SECONDARY_HANDLE = 'printed-rayon-viscose-jacquard-170-gsm';
  var LEGACY_SECONDARY_HANDLE = 'turkish-printed-rayon-viscose-jacquard-fabric-kopya';
  var WRAPPER_VERSION = '20260916-gallery-routes-v4';

  function currentHandle() {
    var productInfo = document.querySelector('product-info[data-product-handle]');
    if (productInfo && productInfo.dataset.productHandle) return String(productInfo.dataset.productHandle);
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  // Run only on Product 1, exactly where the known-good family controller is intended to run.
  if (currentHandle() !== PRIMARY_HANDLE) return;

  var stagedRoutes = (window.__hibaCrossProductStaged || {}).routing || {};
  Object.keys(stagedRoutes).forEach(function (key) {
    if (stagedRoutes[key].handle === LEGACY_SECONDARY_HANDLE) stagedRoutes[key].handle = SECONDARY_HANDLE;
  });

  var miniPalmRoutes = {
    'P2::45411368599734': {
      handle: SECONDARY_HANDLE,
      design: 'D# 1957',
      design_display_name: 'Mini Palm Tree Design',
      photos: [
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-olive-green-soft-drape-view.jpg?v=1788863581',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-olive-green-front-back-view.jpg?v=1788863581',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-olive-green-full-pattern-view.jpg?v=1788863581',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-olive-green-gathered-drape-view.jpg?v=1788863581',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-olive-green-layered-fold-view.jpg?v=1788863581',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-olive-green-texture-close-up.jpg?v=1788863582'
      ]
    },
    'P2::45411370827958': {
      handle: SECONDARY_HANDLE,
      design: 'D# 1957',
      design_display_name: 'Mini Palm Tree Design',
      photos: [
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-mocha-brown-soft-drape-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-mocha-brown-front-back-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-mocha-brown-full-pattern-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-mocha-brown-gathered-drape-view.jpg?v=1788863596',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-mocha-brown-layered-fold-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-mocha-brown-texture-close-up.jpg?v=1788863595'
      ]
    },
    'P2::45411373678774': {
      handle: SECONDARY_HANDLE,
      design: 'D# 1957',
      design_display_name: 'Mini Palm Tree Design',
      photos: [
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-plum-purple-soft-drape-view.jpg?v=1788863594',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-plum-purple-front-back-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-plum-purple-full-pattern-view.jpg?v=1788863594',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-plum-purple-gathered-drape-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-plum-purple-layered-fold-view.jpg?v=1788863594',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-plum-purple-texture-close-up.jpg?v=1788863595'
      ]
    },
    'P2::45411377184950': {
      handle: SECONDARY_HANDLE,
      design: 'D# 1957',
      design_display_name: 'Mini Palm Tree Design',
      photos: [
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-jet-black-soft-drape-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-jet-black-front-back-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-jet-black-full-pattern-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-jet-black-gathered-drape-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-jet-black-layered-fold-view.jpg?v=1788863595',
        'https://cdn.shopify.com/s/files/1/0563/6836/5750/files/turkish-printed-rayon-viscose-jacquard-jet-black-texture-close-up.jpg?v=1788863595'
      ]
    }
  };

  var miniPalmSwatches = {
    'P2::45411368599734': { display_name: 'Olive Green', hex_code: '#596247', available: true },
    'P2::45411370827958': { display_name: 'Mocha Brown', hex_code: '#6F4E37', available: true },
    'P2::45411373678774': { display_name: 'Plum Purple', hex_code: '#6B3E5B', available: true },
    'P2::45411377184950': { display_name: 'Jet Black', hex_code: '#000000', available: true }
  };

  // Add the sixth Product 2 design to the existing staged family map. Never
  // create a partial map: the original five routes must already be present.
  if (
    window.__hibaCrossProductStaged &&
    window.__hibaCrossProductStaged.routing &&
    window.__hibaCrossProductStaged.swatches
  ) {
    Object.keys(miniPalmRoutes).forEach(function (key) {
      window.__hibaCrossProductStaged.routing[key] = miniPalmRoutes[key];
      window.__hibaCrossProductStaged.swatches[key] = miniPalmSwatches[key];
    });
    window.__hibaMiniPalmCrossProductRouteCount = 4;
  } else {
    window.__hibaMiniPalmCrossProductError = 'base-staged-routing-missing';
  }

  // Product 2 now exposes clean Design / Color values in Shopify. The proven v2
  // family controller still uses internal route keys, so translate only its
  // private Product 2 .js fetch. Mini Palm uses unique synthetic color keys to
  // avoid colliding with older P2 legacy values such as C# V4-Black.
  if (window.__hibaP2ConsolidationFetchCompat !== true && typeof window.fetch === 'function') {
    var legacyByVariant = {
      '45322155983030': ['D# 2290', 'C# 2290-V1-Black'],
      '45322156048566': ['D# 2290', 'C# V7-Brown'],
      '45322156114102': ['D# 2290', 'C# V11-White'],
      '45322156179638': ['D# 2290', 'C# V10-Navy Blue'],
      '45322156245174': ['D# 1941', 'C# V4-Black'],
      '45322156310710': ['D# 1941', 'C# V5-Brown'],
      '45322156376246': ['D# 1945', 'C# 1945-V2-White'],
      '45322156441782': ['D# 1945', 'C# 1945-V1-Black'],
      '45322156507318': ['D# 2480', 'C# 2480-V1-Black'],
      '45322156572854': ['D# 2480', 'C# 2480-V2-Brown'],
      '45322156605622': ['D# 2480', 'C# V12-Navy Blue'],
      '45322156671158': ['D# 2542', 'C# V36-Bordo'],
      '45322156736694': ['D# 2542', 'C# V35-Brown'],
      '45322156802230': ['D# 2542', 'C# V28-Black'],
      '45411368599734': ['D# 1957', 'P2::45411368599734'],
      '45411370827958': ['D# 1957', 'P2::45411370827958'],
      '45411373678774': ['D# 1957', 'P2::45411373678774'],
      '45411377184950': ['D# 1957', 'P2::45411377184950']
    };

    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isSecondaryJson =
        url.indexOf('/products/' + SECONDARY_HANDLE + '.js') !== -1 ||
        url.indexOf('/products/' + LEGACY_SECONDARY_HANDLE + '.js') !== -1;
      var request = originalFetch.apply(this, args);
      if (!isSecondaryJson) return request;

      return request.then(function (response) {
        if (!response || !response.ok) return response;
        return response.clone().json().then(function (product) {
          if (!product || !Array.isArray(product.variants)) return response;

          product.variants.forEach(function (variant) {
            var legacy = legacyByVariant[String(variant.id || '')];
            if (!legacy) return;

            if (Array.isArray(variant.options)) {
              variant.options = variant.options.slice();
              variant.options[0] = legacy[0];
              variant.options[1] = legacy[1];
            }
            variant.option1 = legacy[0];
            variant.option2 = legacy[1];
          });

          var headers = new Headers(response.headers);
          headers.set('Content-Type', 'application/json');
          return new Response(JSON.stringify(product), {
            status: response.status,
            statusText: response.statusText,
            headers: headers
          });
        }).catch(function () {
          return response;
        });
      });
    };

    window.__hibaP2ConsolidationFetchCompat = true;
    window.__hibaP2ConsolidationFetchCompatVersion = WRAPPER_VERSION;
  }

  // Keep the proven v2 controller byte-for-byte intact in a separate core asset.
  if (window.__hibaCrossProductCoreLoadRequested === true) return;
  window.__hibaCrossProductCoreLoadRequested = true;

  var current = document.currentScript && document.currentScript.src;
  if (!current) return;
  var clean = current.split('?')[0];
  var coreUrl = clean.replace(/hiba-cross-product-extension\.js$/, 'hiba-cross-product-extension.core-v2.js');
  if (coreUrl === clean) return;

  var core = document.createElement('script');
  core.src = coreUrl + '?v=' + encodeURIComponent(WRAPPER_VERSION);
  core.async = false;
  core.dataset.hibaCrossProductCore = 'v2';
  core.onerror = function () {
    window.__hibaCrossProductCoreLoadError = true;
  };
  document.head.appendChild(core);
})();
